import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          shape: "circle",
          class: "fixed bottom-4 right-4 z-50 bg-blue-900 hover:bg-white text-white hover:text-blue-900 focus:outline-none",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.selectedLanguage), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      title: _ctx.$t('TRANSLATION_SECTION.SELECT_LANGUAGE_LABEL'),
      visible: _ctx.showModal,
      onOk: _ctx.handleOk,
      onCancel: _ctx.handleCancel,
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_radio_group, {
          class: "flex flex-col space-y-2",
          modelValue: _ctx.selectedLanguage,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
          onChange: _ctx.changeLanguage
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang, key) => {
              return (_openBlock(), _createBlock(_component_a_radio_button, {
                key: key,
                value: key,
                class: _normalizeClass(["block mb-2 hover:text-blue-900", {
            'bg-gray-500 text-white ': _ctx.selectedLanguage === key,
          }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(lang), 1)
                ]),
                _: 2
              }, 1032, ["value", "class"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ]),
      _: 1
    }, 8, ["title", "visible", "onOk", "onCancel"])
  ]))
}